// extracted by mini-css-extract-plugin
export var deliveryRow = "_oq-a";
export var fixedHeight = "_oq-4";
export var freightLogo = "_oq-9";
export var fullWidth = "_oq-3";
export var priceColumn = "_oq-5";
export var radioSelected = "_oq-7";
export var radioUnselected = "_oq-6";
export var selectedOption = "_oq-2";
export var selectedOptionContainer = "_oq-1";
export var selection = "_oq-0";
export var tallSkeletonText = "_oq-8";